// extracted by mini-css-extract-plugin
export default {"highlightedArea":"PhaseHighlightedArea-module__highlightedArea___M547q"};